import basicplan_no1 from '@/assets/images/ads/basicplan_no1.png';
import basicplan_no2 from '@/assets/images/ads/basicplan_no2.png';
import basicplan_no3 from '@/assets/images/ads/basicplan_no3.png';
import basicplan_no4 from '@/assets/images/ads/basicplan_no4.png';
import basicplan_no5 from '@/assets/images/ads/basicplan_no5.png';
import basicplan_no1_en from '@/assets/images/ads/basicplan_no1_en.png';
import basicplan_no2_en from '@/assets/images/ads/basicplan_no2_en.png';
import basicplan_no3_en from '@/assets/images/ads/basicplan_no3_en.png';
import basicplan_no4_en from '@/assets/images/ads/basicplan_no4_en.png';
import basicplan_no5_en from '@/assets/images/ads/basicplan_no5_en.png';

/**
 * 広告データを配列として定義
 * @type {Ad[]} ads: 広告データの配列
 */
export type Ad = string;

const createAd = (href: string, alt: string, src: string): Ad => `
<a href="${href}" rel="nofollow" style="display: block; width: 100%; height: 100%">
    <img border="0" alt="${alt}" src="${src}" style="display: block; width: 100%; height: 100%; max-width: 100%; max-height: 100%; object-fit: contain;">
</a>`;

const adsJa: Ad[] = [
    createAd(
        '/plans?sessionContext=adpannel_basicplan_banner1_expanding_search_period',
        'ベーシックプラン広告バナー1',
        basicplan_no1,
    ),
    createAd(
        '/plans?sessionContext=adpannel_basicplan_banner2_no_ads',
        'ベーシックプラン広告バナー2',
        basicplan_no2,
    ),
    createAd(
        '/plans?sessionContext=adpannel_basicplan_banner3_previous_period_comparison',
        'ベーシックプラン広告バナー3',
        basicplan_no3,
    ),
    createAd(
        '/plans?sessionContext=adpannel_basicplan_banner4_expanded_activity_calendars',
        'ベーシックプラン広告バナー4',
        basicplan_no4,
    ),
    createAd(
        '/plans?sessionContext=adpannel_basicplan_banner5_custom_layout',
        'ベーシックプラン広告バナー5',
        basicplan_no5,
    ),
];

const adsEn: Ad[] = [
    createAd(
        '/plans?sessionContext=adpannel_basicplan_banner1_expanding_search_period',
        'Basic Plan advertisement banner 1',
        basicplan_no1_en,
    ),
    createAd(
        '/plans?sessionContext=adpannel_basicplan_banner2_no_ads',
        'Basic Plan advertisement banner 2',
        basicplan_no2_en,
    ),
    createAd(
        '/plans?sessionContext=adpannel_basicplan_banner3_previous_period_comparison',
        'Basic Plan advertisement banner 3',
        basicplan_no3_en,
    ),
    createAd(
        '/plans?sessionContext=adpannel_basicplan_banner4_expanded_activity_calendars',
        'Basic Plan advertisement banner 4',
        basicplan_no4_en,
    ),
    createAd(
        '/plans?sessionContext=adpannel_basicplan_banner5_custom_layout',
        'Basic Plan advertisement banner 5',
        basicplan_no5_en,
    ),
];

export const getAds = (languageTag?: string): Ad[] => {
    const lang = languageTag?.toLowerCase() ?? 'ja';
    return lang.startsWith('en') ? adsEn : adsJa;
};
